import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    const main = document.querySelector('.desktop-main-content')
    if (main instanceof HTMLElement) main.scrollTop = 0
  }, [pathname])

  return null
}

export default ScrollToTop
